var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-form',{staticClass:"mod-order-form",attrs:{"layout":"horizontal","labelAlign":"left","label-col":_vm.labelCol,"wrapper-col":_vm.wrapperCol,"colon":false,"form":_vm.form},on:{"submit":_vm.onSubmit}},[_c('a-form-item',{attrs:{"wrapper-col":_vm.wrapperColOffset}},[_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("请输入任意一次一年内出行的订单信息")])]),_c('a-form-item',{attrs:{"label":"乘机人"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
        'fullName',
        {
          rules: [
            {
              validator: _vm.handleFieldValidate
            }
          ],
          validateTrigger: 'blur'
        }
      ]),expression:"[\n        'fullName',\n        {\n          rules: [\n            {\n              validator: handleFieldValidate\n            }\n          ],\n          validateTrigger: 'blur'\n        }\n      ]"}],attrs:{"size":"large","placeholder":"请输入行程中的一位乘机人姓名"}})],1),_c('a-form-item',{attrs:{"label":"出发城市"}},[_c('air-flight-city-selector',{directives:[{name:"decorator",rawName:"v-decorator",value:([
        'departure',
        {
          rules: [
            {
              validator: _vm.handleFieldValidate
            }
          ]
        }
      ]),expression:"[\n        'departure',\n        {\n          rules: [\n            {\n              validator: handleFieldValidate\n            }\n          ]\n        }\n      ]"}],attrs:{"data-source":_vm.cities,"size":"large","placeholder":"出发城市"}},[_c('a-icon',{attrs:{"slot":"suffix","type":"environment"},slot:"suffix"})],1)],1),_c('a-form-item',{attrs:{"label":"到达城市"}},[_c('air-flight-city-selector',{directives:[{name:"decorator",rawName:"v-decorator",value:([
        'arrival',
        {
          rules: [
            {
              validator: _vm.handleFieldValidate
            }
          ]
        }
      ]),expression:"[\n        'arrival',\n        {\n          rules: [\n            {\n              validator: handleFieldValidate\n            }\n          ]\n        }\n      ]"}],attrs:{"data-source":_vm.cities,"size":"large","placeholder":"到达城市"}},[_c('a-icon',{attrs:{"slot":"suffix","type":"environment"},slot:"suffix"})],1)],1),_c('a-form-item',{attrs:{"wrapper-col":_vm.wrapperColOffset}},[_c('a-button',{staticStyle:{"margin":"0","width":"100%"},attrs:{"type":"primary","size":"large","loading":_vm.loading,"html-type":"submit"}},[_vm._v("提交校验")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }